import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Post } from 'src/app/models/post';
import { ModalPicturePage } from '../modal-picture/modal-picture.page';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss'],
})
export class PostsComponent implements OnInit {

  @Input() posts: Post[];

  constructor(private modalCtrl: ModalController, private homeService: HomeService) { 
  }

  ngOnInit() {}

  async openModalPicture(photo: string) {
    const modal = await this.modalCtrl.create({
      component: ModalPicturePage,
      componentProps: {
        photo,
      },
      cssClass: 'transparent-modal',
    });
    return await modal.present();
  }
}
